<script setup>
import { ref, watch } from 'vue'
import { DxTextBox } from 'devextreme-vue/text-box'
import { getI18n } from '@/plugins/i18n'

const props = defineProps({
  cellInfo: { type: Object, required: true },
  disabled: { type: Boolean, default: false },
  allowBlankSpaces: { type: Boolean, default: false },
  disabledIcon: { type: Boolean, default: false },
  action: { type: Function, required: true },
})

const emit = defineEmits(['initialized'])

const i18n = getI18n()
const loading = ref(false)
const plate = ref(props.cellInfo.value ?? '')

watch(() => props.cellInfo.value, (v) => { plate.value = v ?? '' })

const normalize = (value) => {
  let v = (value || '').toUpperCase()
  if (!props.allowBlankSpaces) {
    v = v.replace(/\s+/g, '')
  }
  return v
}

const onValueChanged = (e) => {
  const normalized = normalize(e.value)
  plate.value = normalized
  if (normalized !== e.value) {
    e.component.option('value', normalized)
    return
  }
  props.cellInfo.setValue(normalized)
}

const onClick = async() => {
  if (!plate.value || loading.value) return
  loading.value = true
  try {
    await props.action(plate.value)
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div style="display: flex; align-items: center; gap: 0.25rem;">
    <dx-text-box
      :value="plate"
      :disabled="disabled"
      :max-length="7"
      style="flex: 1;"
      @initialized="e => emit('initialized', e.component)"
      @value-changed="onValueChanged"
    />
    <q-btn
      icon="mdi-poll"
      flat
      dense
      round
      size="sm"
      color="primary"
      :loading="loading"
      :disable="disabledIcon || !plate"
      @click.stop="onClick"
    >
      <q-tooltip>{{ i18n.t('common.instantWeb') }}</q-tooltip>
    </q-btn>
  </div>
</template>
